import { render } from "./pButton.vue?vue&type=template&id=761c7db7&scoped=true"
import script from "./pButton.vue?vue&type=script&lang=js"
export * from "./pButton.vue?vue&type=script&lang=js"

import "./pButton.vue?vue&type=style&index=0&id=761c7db7&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761c7db7"]])

export default __exports__